// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"05901c11","208":"adeb19e4","328":"070a2c57","496":"63456f12","512":"b9a6bf7e","544":"3665aa64","556":"899b0434","800":"c60606de","808":"195ee794","852":"74ba9c54","864":"94128fef","912":"68f3afb4"}[chunkId] + ".chunk.js";
};